import BertieIcon from './BertieIcon';

export default BertieIcon;
